if (!customElements.get('series-filter')) {
    customElements.define('series-filter', class Series extends HTMLElement {
        constructor() {
            super();
            this.pagination_count = 21;
            this.currentPage = 1;
            this.paginationContainer = document.querySelector('.series__pagination');
            this.currentURL = new URL(window.location.href);
            this.params = new URLSearchParams(this.currentURL.search)
            this.allWorkout = document.querySelectorAll('[workout-card]');
            this.filteredWorkout = [];
            this.form = this.querySelector('form')
            this.pageCount = parseInt(this.dataset.pageCount);
            this.activeBar = document.querySelectorAll('.series__active-bar');
            this.rangeSlider = ["duration"];
            this.seriesBar = document.querySelector('.series-filter__bar');

            if (this.params.get("page") != "" && this.params.get("page") != undefined) {
                this.currentPage = this.params.get("page");
            }
            this.initFilter();
        }

        initPagination(pageCount, availableContents) {
            this.allWorkout.forEach((workout) => {
                workout.setAttribute('hidden', '');
            })
            // Show contents
            var min = (this.currentPage - 1) * this.pagination_count;
            var max = min + this.pagination_count;
            availableContents.forEach((card, i) => {
                if (i >= min && i < max) {
                    card.removeAttribute('hidden');
                } else {
                    card.setAttribute('hidden', '');
                }
            });

            this.paginationContainer.innerHTML = "";
            if (pageCount == 1) return
            // Previous arrow
            if (pageCount > 1) {
                var prev_hidden = "";
                if (this.currentPage == 1) {
                    prev_hidden = "hidden";
                }
                this.params.set('page', this.currentPage - 1);
                this.paginationContainer.innerHTML += `
                <a class="pagination__item group" rel="prev" aria-label="Go to page ${this.currentPage - 1}" href="${this.currentURL.origin}${this.currentURL.pathname}?${this.params.toString()}" ${prev_hidden} prev-arrow><span class="animated-arrow animated-arrow-v2 animated-arrow--reverse"></span></a>`; 
            }
 
            // Pages
            var current_attribute = "";
            for (let i = 0; i < pageCount; i++) {
                if ((i + 1) == this.currentPage) {
                    current_attribute = `aria-current="page"`;
                } else {
                    current_attribute = "";
                }
                this.params.set('page', i + 1);
                this.paginationContainer.innerHTML += `<a class="pagination__link pagination__item h6" aria-label="Go to page ${i + 1}" href="${this.currentURL.origin}${this.currentURL.pathname}?${this.params.toString()}" ${current_attribute} page="${i+1}">${i + 1}</a>`;
            }

            if (pageCount > 1) {
                var next_hidden = "";
                if (this.currentPage >= parseInt(this.dataset.pageCount)) {
                    next_hidden = "hidden";
                }   
                // Next Arrow
                this.params.set('page', parseInt(this.currentPage) + 1);
                this.paginationContainer.innerHTML += `
                <a class="pagination__item group" rel="next" aria-label="Go to page ${parseInt(this.currentPage) + 1}" href="${this.currentURL.origin}${this.currentURL.pathname}?${this.params.toString()}" ${next_hidden} next-arrow><span class="animated-arrow animated-arrow-v2"></span></a>`;
            }
            
            this.paginationContainer.querySelectorAll('.pagination__item').forEach((page) => {
                page.addEventListener('click', (e) => {
                    e.preventDefault();
                    var page_url = new URL(page.getAttribute('href'));
                    var pageSearchParams = page_url.searchParams;
                    var pageNumber = parseInt(pageSearchParams.get('page'));
                    var min = (pageNumber - 1) * this.pagination_count;
                    var max = min + this.pagination_count;
                    availableContents.forEach((card, i) => {
                        if (i >= min && i < max) {
                            card.removeAttribute('hidden');
                        } else {
                            card.setAttribute('hidden', '');
                        }
                    });

                    history.replaceState(null, '', page_url);

                    this.paginationContainer.querySelectorAll('.pagination__item').forEach((p) => {
                        p.removeAttribute('aria-current');
                    })
                    this.paginationContainer.querySelector(`[page="${pageNumber}"]`).setAttribute('aria-current', "page");
                    pageSearchParams.set('page', pageNumber - 1)
                    this.paginationContainer.querySelector('[prev-arrow]').setAttribute('href', page_url);
                    if ((pageNumber - 1) <= 0) {
                        this.paginationContainer.querySelector('[prev-arrow]').setAttribute('hidden', '');
                    } else {
                        this.paginationContainer.querySelector('[prev-arrow]').removeAttribute('hidden');
                    }
                    pageSearchParams.set('page', pageNumber + 1)
                    this.paginationContainer.querySelector('[next-arrow]').setAttribute('href', page_url);
                    console.log(this.dataset.pageCount + " : " + (pageNumber + 1))
                    if ((pageNumber + 1) > parseInt(this.dataset.pageCount)) {
                        this.paginationContainer.querySelector('[next-arrow]').setAttribute('hidden', '');
                    } else {
                        this.paginationContainer.querySelector('[next-arrow]').removeAttribute('hidden');
                    }
                })
            })
            
        }
        updateActiveFilter() {
            this.activeFilters = this.querySelectorAll('input:checked');
            
            this.activeBar.forEach((bar) => {
                var activeBar = bar.querySelector('.series__active-filter');
                bar.querySelector('.series__workout-count').querySelector("span").textContent = this.filteredWorkout.length;
                activeBar.innerHTML = "";
                if (this.activeFilters.length > 0) {
                    this.activeFilters.forEach((filter) => {
                        const filterName = filter.getAttribute("name");
                        if (!this.rangeSlider.includes(filterName)) {
                            activeBar.innerHTML += `<filter-remove name="${filter.getAttribute("name")}" value="${filter.value}" class="text-xs uppercase">${filter.value} <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.81787 3.06812L9.18183 9.43208" stroke="#11171B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.81787 9.43188L9.18183 3.06792" stroke="#11171B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></filter-remove>`
                        }
                        
                    })

                    if (this.activeFilters.length == 1 && this.rangeSlider.includes(this.activeFilters[0].getAttribute("name"))) {
                        
                    } else {
                        activeBar.innerHTML += `<filter-remove name="all" class="link uppercase clear-all text-xxxs uppercase">CLEAR ALL</filter-remove>`;
                    }
                   
                }
            })
            
        }
        initFilter() {
            console.log("Init Form");
            this.form.addEventListener('input', () => {
                this.updateWorkouts()
            });

            this.params.forEach((value, key) => {
                const splitValue = value.split(',').map(v => v.trim());
                for (let i = 0; i < splitValue.length; i++) {
                    if (splitValue[i]) {
                        const input = this.querySelector(`[name="${key}"][value="${splitValue[i]}"]`);
                        // Check if input exists before setting checked property
                        if (input) {
                            input.checked = true;
                        }
                    }
                }
            })
            const firstCheckedInput = document.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked');
            // Check if an input was found
            if (firstCheckedInput) {
                this.updateWorkouts();
            } else {
                this.initPagination(this.pageCount, this.allWorkout);
            }

            this.seriesBar.addEventListener('click', ()=> {
                if (this.seriesBar.getAttribute('aria-expanded') == "false") {
                    this.seriesBar.setAttribute('aria-expanded', true);
                } else {
                    this.seriesBar.setAttribute('aria-expanded', false);
                }
            })
        }
        updateWorkouts() {
            // Get active filters
            console.log("Check active filter")
            var formData = new FormData(this.form);
            var allParam = {};
            this.searchParams = new URLSearchParams(formData);
            this.searchParams.forEach((value, key) => {
                if (allParam[key] == undefined) {
                    allParam[key] = [];
                }
                allParam[key].push(value);
            });
            this.filteredWorkout = this.getFilteredWorkout(allParam);
            this.currentPage = 1;
            this.currentURL.search = "";
            this.params = new URLSearchParams(this.currentURL.search);
            this.params.set("page", 1);
            Object.keys(allParam).forEach((key) => {
                this.params.set(key, allParam[key].join(', '));
            });
            this.currentURL.search = this.params.toString();
            history.replaceState(null, "",  this.currentURL.toString())

            console.log(this.filteredWorkout)
            this.initPagination(Math.ceil(this.filteredWorkout.length / this.pagination_count), this.filteredWorkout);
            this.updateActiveFilter();
        }
        getFilteredWorkout(allParam) {
            var filteredWorkout = Array.from(this.allWorkout);
            Object.keys(allParam).forEach((key) => {
                filteredWorkout = filteredWorkout.filter((workout) => {
                    // Get the attribute value and split it into an array
                    const values = workout.getAttribute(key).split(',')
                    return values.some(value => allParam[key].includes(value));
                });
            })
            return filteredWorkout
        }
    })
}

if (!customElements.get('filter-remove')) {
    customElements.define('filter-remove', class filterRemove extends HTMLElement {
        constructor() {
            super();
            this.name = this.getAttribute('name');
            this.input = document.querySelectorAll(`[type="checkbox"][name="${this.name}"]`);
            this.form = this.closest('form');
            this.rangeSlider = ["durations"];
            if (this.form == undefined) {
                this.form = document.querySelector('#series-form');
            }
            this.addEventListener('click', this.clear.bind(this));
        }
        clear() {
            if (this.getAttribute("name") == "all") {
                this.form.querySelectorAll('[type="checkbox"]:checked').forEach((input) => {
                    input.checked = false;
                })
            } else if(this.rangeSlider.includes(this.name)) {
                const sliders = document.querySelectorAll(`[group="${this.name}"]`);
                sliders[0].value = sliders[0].getAttribute('min');
                sliders[1].value = sliders[1].getAttribute('max');
                sliders[0].dispatchEvent(new Event("input"), {
                    bubbles: true
                })
            } else if (this.getAttribute("value") != undefined) {
                document.querySelector(`[type="checkbox"][name="${this.name}"][value="${this.getAttribute("value")}"]`).checked = false;
            } else {
                this.input.forEach((input) => {
                    input.checked = false;
                });
            }
            
            if (this.form != undefined) {
                this.form.dispatchEvent(new Event("input"));
            }
        }
    })
}

var CustomSlider = class extends HTMLElement {
    constructor() {
      super();
      console.log("init custom slider")
        this.sliders = this.querySelectorAll('[type="range"]');
        this.filters = this.querySelectorAll('[type="checkbox"]');
        this.min_label = this.querySelector('.label-min');
        this.max_label = this.querySelector('.label-max');
        this.minValue = this.sliders[0].getAttribute('min');
        this.maxValue = this.sliders[0].getAttribute('max');
        this.progressBar = this.querySelector('.fa-custom-slider__active-bar');
        this.sliders.forEach((slider) => {
            slider.addEventListener('input', this.updateSlider.bind(this))
        });
    }
    updateSlider(e) {
        this.min = this.sliders[0];
        this.max = this.sliders[1];
        if (parseFloat(e.target.value) >= parseFloat(this.max.value) && e.target != this.max) {
            e.target.value = parseInt(this.max.value - 1);
        } else if (parseFloat(e.target.value) <= parseFloat(this.min.value) && e.target != this.min) {
            this.max.value = parseInt(this.min.value) + 1;
        }
        this.min_label.textContent = this.min.value + " min";
        this.max_label.textContent = this.max.value + " min";

        if (this.filters.length > 1) {
            this.updateFilter();
        }

        var minWidth = this.getPercentage(this.min);
        var maxWidth = 100 - this.getPercentage(this.max);
        console.log("update slider")
        console.log(minWidth);
        console.log(maxWidth)
        var progressWidth = 100 - minWidth - maxWidth;
        this.progressBar.style.width = progressWidth + "%";
        this.progressBar.style.left = minWidth + "%";
    }
    getPercentage(input) {
        const min = input.min ? parseInt(input.min) : 0;
        const max = input.max ? parseInt(input.max) : 100;
        const value = input.value ? parseInt(input.value) : 0;

        // Calculate percentage
        const percentage = ((value - min) / (max - min)) * 100;
        return percentage
    }
    updateFilter() {
        this.filters.forEach((filter) => {
            const filterValue = parseFloat(filter.value.replace("MIN", "").trim());
            if (filterValue >= parseFloat(this.min.value) && filterValue <= parseFloat(this.max.value)) {
                filter.checked = true;
            } else {
                filter.checked = false;
            }
        })
    }
}
window.customElements.define("fa-custom-slider", CustomSlider);